import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { LocationStateModule } from './+state/location.state.module';
import { LocationService } from './services';
import { LocationFacade } from './+state';

@NgModule({
  imports: [CommonModule, LocationStateModule],
})
export class DomainLocationModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainLocationModule,
      providers: [LocationService, LocationFacade],
    };
  }
}
